module.exports = __webpack_public_path__ + "static/media/12.1ca5d8db.png";